import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  colors: {
    primary: '#4361EE',    // Main blue
    secondary: '#7209B7',  // Purple accent
    tertiary: '#4895EF',   // Light blue accent
    background: '#FFFFFF',
    backgroundAlt: '#F8F9FC', // Lighter background for content areas
    backgroundDark: '#0C1528', // Dark navy for header/footer (from screenshot)
    text: '#1E293B',       // Dark slate for text
    textLight: '#64748B',  // Medium slate for secondary text
    textDark: '#FFFFFF',   // White text for dark backgrounds
    border: '#E2E8F0',     // Light border color
    success: '#10B981',    // Professional green
    error: '#EF4444',      // Professional red
    warning: '#F59E0B',    // Professional amber
    delivered: '#10B981',  // Green for completed items
    sent: '#4361EE',       // Blue for sent items
    waitingApproval: '#F59E0B', // Yellow/orange for waiting items
    gradient: {
      primary: 'linear-gradient(135deg, #4361EE 0%, #7209B7 100%)',
      secondary: 'linear-gradient(135deg, #0C1528 0%, #263566 100%)',
    }
  },
  fonts: {
    primary: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  fontSizes: {
    xs: '0.875rem',     // Increased from 0.75rem for better readability
    sm: '1rem',         // Increased from 0.875rem
    md: '1.125rem',     // Increased from 1rem
    lg: '1.25rem',      // Increased from 1.125rem
    xl: '1.5rem',       // Increased from 1.25rem
    '2xl': '1.75rem',   // Increased from 1.5rem
    '3xl': '2rem',      // Increased from 1.875rem
    '4xl': '2.5rem',    // Increased from 2.25rem
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    full: '9999px',
  },
  spacing: {
    '0': '0',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '8': '2rem',
    '10': '2.5rem',
    '12': '3rem',
    '16': '4rem',
    '20': '5rem',
  },
  boxShadow: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.05), 0 4px 6px rgba(0, 0, 0, 0.08)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.07), 0 10px 10px rgba(0, 0, 0, 0.05)',
    card: '0 2px 8px rgba(0, 0, 0, 0.08)',
    hover: '0 8px 16px rgba(67, 97, 238, 0.12)',
    table: '0 1px 6px rgba(0, 0, 0, 0.05)',
  },
  transitions: {
    default: '0.3s ease',
    fast: '0.15s ease',
    slow: '0.5s ease',
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
}; 